require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-pack-the-pantries.json") })
        }
      }, "path---articles-tags-pack-the-pantries");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-pack-the-pantries!./.cache/json/articles-tags-pack-the-pantries.json
// module id = 1915
// module chunks = 231608221292675